import {nextTick} from 'vue'

async function waitForElement(selector: string, timeout = 1000) {
	const start = performance.now()
	return new Promise<HTMLElement | null>((resolve) => {
		const check = () => {
			const el = document.querySelector(selector)
			if (el) return resolve(el as HTMLElement)
			if (performance.now() - start > timeout) return resolve(null)
			requestAnimationFrame(check)
		}
		check()
	})
}

export default {
	async scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition

		const { gsap } = useGSAP()
		const OFFSET = 155

		if (to.hash) {
			await nextTick()
			const el = await waitForElement(to.hash)
			if (el) {
				const ss = gsap.ScrollSmoother?.get()
				if (ss) {
					ss.scrollTo(el, true, `top ${OFFSET}px`)
				} else {
					gsap.to(window, {scrollTo: { y: el, offsetY: OFFSET }, duration: 0.3})
				}
				return false
			}
		}

		const ss = gsap.ScrollSmoother?.get()
		if (ss) {
			ss.scrollTo(0)
		} else {
			gsap.to(window, {scrollTo: 0, duration: 0.3})
		}
		return false
	}
}
